import _ from 'lodash'
import moment from 'moment'

export const formatNumberAndCurrency = (number) => {
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(number)
}

export const formatNumberAndInstallments = (number) => {
    return _.round(number, 2) + ' Ins.'
}

export const formatNumberAndPercents = (number) => {
    return _.round(number, 2) + '%'
}

export const formatDate = (add = null, substract = null) => {
    if (add !== null) {
        return moment().add(add, 'days').format('DD.MM.YYYY')
    }
    if (substract !== null) {
        return moment().subtract(substract, 'days').format('DD.MM.YYYY')
    }
}
